import { render, staticRenderFns } from "./warranty.vue?vue&type=template&id=1886dbb2&scoped=true&"
import script from "./warranty.vue?vue&type=script&lang=js&"
export * from "./warranty.vue?vue&type=script&lang=js&"
import style0 from "./warranty.vue?vue&type=style&index=0&id=1886dbb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1886dbb2",
  null
  
)

export default component.exports